/* OBFUSCATED CODE - INTELLECTUAL PROPERTY PROTECTED */
'use client';
import React from 'react';
import styles from './Button.module.css';
export default function Button({
    children,
    variant = 'primary',
    size = 'md',
    shape = 'default',
    fullWidth = false,
    className = '',
    as: Component = 'button',
    ...props
}) {
    const buttonClasses = [
        styles.button,
        styles[variant],
        styles[size],
        styles[`shape-${shape}`],
        fullWidth ? styles.fullWidth : '',
        className
    ].filter(Boolean).join(' ');
    return (
        <Component className={buttonClasses} {...props}>
            {children}
        </Component>
    );
}
